import { DeliveryLocation } from "../../__generated__/types";

export interface DeliveryLocationDetail {
  label: string;
  name: string;
  address: string;
  city: string;
  value: DeliveryLocation;
  pickupDay: number;
  logo: string;
  shopDays: number[];
  shopHours: string[];
  color: string;
  lat: number;
  lng: number;
  onlyTrial?: boolean;
}

export const deliveryLocations: DeliveryLocationDetail[] = [
  {
    label:
      'WECHELDERZANDE: Kobe Helsen (boer), Gebroeders de Winterstraat 40',
    name: 'Kobe Helsen',
    address: 'Gebroeders de Winterstraat 40',
    city: 'Wechelderzande',
    value: DeliveryLocation.WECHELDERZANDE,
    //deprecated
    pickupDay: 5,
    logo: 'groentegeweld.jpeg',
    shopDays: [5],
    shopHours: ['van 16u00 tot 21u00'],
    color: 'rgb(19 87 17)',
    lat: 51.2613214,
    lng: 4.7907499,
  },
  {
    label: 'Merksplas: Center Peeraer, Steenweg op Turnhout 74',
    name: 'Center Peeraer',
    address: 'Steenweg op Turnhout 74',
    city: 'Merksplas',
    value: DeliveryLocation.MERKSPLAS,
    //deprecated
    pickupDay: 5,
    logo: 'centerPeeraer.png',
    shopDays: [5],
    shopHours: ['van 15u30 tot 18u00'],
    color: 'delivery-location-1',
    lat: 51.3606,
    lng: 4.8636,
  },
  {
    label: 'Arendonk: Dirk Hendrix, Hertevelden 13',
    city: 'Arendonk',
    value: DeliveryLocation.ARENDONK,
    pickupDay: 5,
    name: 'Dirk Hendrix',
    address: 'Hertevelden 13',
    logo: 'groentegeweld.jpeg',
    shopDays: [1, 3, 5],
    shopHours: ['van 16u00 tot 21u00'],
    color: 'delivery-location-2',
    lat: 51.3247,
    lng: 5.0828,
  },
  {
    label: 'Weelde: Groentegeweld, Weeldestraat 168',
    city: 'Weelde',
    value: DeliveryLocation.WEELDE,
    pickupDay: 5,
    name: 'Groentegeweld',
    address: 'Weeldestraat 168',
    logo: 'groentegeweld.jpeg',
    shopDays: [1, 3, 5, 6],
    shopHours: ['van 13u00 tot 21u00'],
    color: 'delivery-location-3',
    lat: 51.4073,
    lng: 4.9905,
  },
  {
    label: 'Oud-Turnhout: Omloop, Kerkstaat 1',
    name: 'Omloop',
    address: 'Kerkstaat 1',
    city: 'Oud-Turnhout',
    value: DeliveryLocation.OUD_TURNHOUT,
    pickupDay: 5,
    logo: 'omloop.png',
    shopDays: [5],
    shopHours: ['van 15u30 tot 18u00'],
    color: 'delivery-location-4',
    lat: 51.3194,
    lng: 4.9841,
  },
  {
    label: 'Turnhout: ToBe Kempen, Hendrik Consciencestraat 20',
    name: 'ToBe Kempen',
    address: 'Hendrik Consciencestraat 20',
    city: 'Turnhout',
    value: DeliveryLocation.TURNHOUT,
    pickupDay: 5,
    logo: 'tobe.jpeg',
    shopDays: [5],
    shopHours: ['van 15u00 tot 21u00'],
    color: 'delivery-location-5',
    lat: 51.3232,
    lng: 4.9496,
  },
  {
    label: 'Ravels: Tinne Adams, O.L.Vrouwstraat 76',
    city: 'Ravels',
    value: DeliveryLocation.RAVELS,
    pickupDay: 5,
    name: 'Tinne Adams',
    address: 'O.L.Vrouwstraat 76',
    logo: 'groentegeweld.jpeg',
    shopDays: [5],
    shopHours: ['van 15u tot 16u00'],
    color: 'delivery-location-6',
    lat: 51.3735,
    lng: 4.9907,
  },
  {
    label: 'Baarle-Nassau: Kukelekoe, Heikant 7',
    name: 'Kukelekoe',
    address: 'Heikant 7',
    city: 'Baarle-Nassau',
    value: DeliveryLocation.BAARLE_NASSAU,
    pickupDay: 5,
    logo: 'kukelekoe.png',
    shopDays: [5],
    shopHours: ['van 14u30 tot 16u00'],
    color: 'delivery-location-7',
    lat: 51.4385,
    lng: 4.9293,
  },
  {
    label: 'ALPHEN: Oard, Boshoven 29',
    name: 'Oard',
    address: 'Boshoven 29',
    city: 'Alphen',
    value: DeliveryLocation.ALPHEN,
    pickupDay: 5,
    logo: 'oard.png',
    shopDays: [5],
    shopHours: ['van 14u30 tot 16u00'],
    color: 'rgb(236,135,165)',
    lat: 51.4855,
    lng: 4.9587,
  },
  {
    label: "RIEL: Beleefboerderij Van 't Zandeind, Zandeind 32a - 34",
    name: "Beleefboerderij Van 't Zandeind",
    address: 'Zandeind 32a - 34',
    city: 'Riel',
    value: DeliveryLocation.RIEL,
    pickupDay: 5,
    logo: 'vantzandeind.png',
    shopDays: [5],
    shopHours: ['van 14u30 tot 17u00'],
    color: 'rgb(21,195,195)',
    lat: 51.5277,
    lng: 5.0318,
  },
];

export const toReadableDeliveryLocation = (deliveryLocation: DeliveryLocation) => {
  return deliveryLocations.find(dl => dl.value === deliveryLocation)?.label;
};

export const toCity = (deliveryLocation: DeliveryLocation | null | undefined) => {
  let city;
  if (deliveryLocation) {
    city = deliveryLocations.find(dl => dl.value === deliveryLocation)?.city;
  }
  return city || 'onbekend';
};
export const toTag = (deliveryLocation: DeliveryLocation | null | undefined) => `dorp_${toCity(deliveryLocation).toLowerCase()}`;

export const toNameAndCity = (deliveryLocation: DeliveryLocation | null) => {
  let nameAndCity;
  if (deliveryLocation) {
    const deliveryLocationData = deliveryLocations.find(dl => dl.value === deliveryLocation);
    nameAndCity = `${deliveryLocationData?.name}, ${deliveryLocationData?.city}`;
  }
  return nameAndCity || 'onbekend';
};

export const toPickupDay = (deliveryLocation: DeliveryLocation) => {
  return deliveryLocations.find(dl => dl.value === deliveryLocation)?.pickupDay;
};

export const toColor = (deliveryLocation: DeliveryLocation) => {
  return deliveryLocations.find(dl => dl.value === deliveryLocation)?.color;
};

export const deliveryLocationValueToDetail = (deliveryLocation: DeliveryLocation) => {
  return deliveryLocations.find(dl => dl.value === deliveryLocation);
};
